/**
 * Retrieves mandate information from Stripe.
 *
 * @param intentId - The ID of the payment intent to retrieve mandate information for.
 *
 * @returns A promise that resolves with the mandate information, or rejects with an error if the request fails.
 */
import axiosInstance from 'integration/api/axiosInstance';

export const getMandateInfo = (intentId: string) =>
  axiosInstance.get(`/stripe/mandate-info?intentId=${intentId}`);
